import React from 'react';
import { ArrowUpIcon, ArrowDownIcon } from '@radix-ui/react-icons';
import { formatIST, getRelativeTime } from '../../../utils/datetime';
import styles from './SignalCard.module.css';

const formatPrice = (price) => {
  if (!price && price !== 0) return '—';
  return `₹${Number(price).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const SignalCard = ({ signal }) => {
  const isBuy = signal.action_type === 'BUY';
  const ist = formatIST(signal.signal_time);

  return (
    <div className={`${styles.card} ${isBuy ? styles.buyCard : styles.sellCard}`}>
      <div className={styles.actionIcon}>
        {isBuy ? <ArrowUpIcon width={22} height={22} /> : <ArrowDownIcon width={22} height={22} />}
      </div>

      <div className={styles.content}>
        <div className={styles.topRow}>
          <span className={`${styles.actionBadge} ${isBuy ? styles.buyBadge : styles.sellBadge}`}>
            {signal.action_type}
          </span>
          {signal.signal_type && (
            <span className={`${styles.typeBadge} ${signal.signal_type === 'EXIT' ? styles.exitBadge : styles.entryBadge}`}>
              {signal.signal_type}
            </span>
          )}
          <span className={styles.symbol}>{signal.symbol}</span>
        </div>

        <div className={styles.details}>
          <span className={styles.price}>{formatPrice(signal.trigger_price)}</span>
          <span className={styles.dot}>•</span>
          <span className={styles.strategy}>{signal.strategy_name || `Strategy #${signal.strategy_id}`}</span>
        </div>
      </div>

      <div className={styles.statusCol}>
        <span className={`${styles.status} ${signal.status === 'executed' ? styles.statusExecuted : styles.statusPending}`}>
          {signal.status || 'pending'}
        </span>
      </div>

      <div className={styles.meta}>
        <span className={styles.time} title={getRelativeTime(signal.signal_time)}>
          {ist ? (
            <>
              <span className={styles.timeClock}>{ist.clock}</span>
              <span className={styles.timeDate}>{ist.date}</span>
            </>
          ) : '—'}
        </span>
      </div>
    </div>
  );
};

export default SignalCard;
